import dayjs from 'dayjs'
import { v4 as uuidv4 } from 'uuid'

export function generateUUID() {
  return uuidv4()
}
export function parseNumber(number: number) {
  // 1000 -> 1,000
  return number.toLocaleString()
}
export function parseNumberStr(number: string) {
  // "1000" -> "1,000"
  return parseNumber(Number(number))
}
export function formatDateToStr(date: Date | null) {
  // 2021-01-01
  if (date === null) return ''
  return dayjs(date).format('YYYY-MM-DD')
}
export const roundDecimal = (value: number, n: number) => Math.round(value * 10 ** n) / 10 ** n
export const ceilDecimal = (value: number, n: number) => Math.ceil(value * 10 ** n) / 10 ** n
export const calcRatio = (latest: number, oldest: number) => ceilDecimal((latest / oldest) * 100 - 100, 2)

// chart utils
export function calcLogNormScale(min: number, max: number, divitions: number) {
  const maxLog = Math.log10(max)
  const minLog = Math.floor(Math.log10(min))

  const logScale = (maxLog - minLog) / divitions
  const scale = Array.from({ length: divitions + 1 }, (_, i) => Math.ceil(10 ** (minLog + logScale * i)))
  return scale
}

// chart utils
export function divideScale(min: number, max: number, divitions: number) {
  const minNum = min > 1 ? min : 0
  const logScale = (max - minNum) / divitions
  const scale = Array.from({ length: 6 }, (_, i) => Math.ceil(minNum + logScale * i))
  return scale
}

// page utils
export function calcOffset(currentPage: number, offset: number) {
  return (currentPage - 1) * offset
}
